<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off">
            <div class="form-group mt-1 mr-2 float-left">
                <label>Denominazione</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                    placeholder="Codice Denominazione" type="text" style="width:150px"
                    v-model="search.DENOMINAZIONE_FORNITORE.VALUE">
            </div>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="creaFornitore()"
                style="margin-top:26px"><i class="fal fa-cart-plus"></i> Crea Fornitore</button>
        </form>
    </div>

    <div class="isprint-grid-container" style="margin-top: 20px;">
        <table class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <!--<isort v-bind:ordinamento.sync="ordinamento" :label="'Cognome e nome'" :campo="'COGNOME'" ></isort>-->
                <tr style="left: 0px;background:#629991;color:#fff">
                    <th style="width:20%"><span>Denominazione</span></th>
                    <th style="width:20%"><span>Logo</span></th>
                    <th style="width:50%"><span>Note</span></th>
                    <th style="width:10%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="fornitore.ID_FORNITORE"
                    v-for="fornitore in paginatedList.arr">
                    <td style="width:20%">
                        <span class="badge badge" style="font-size:17px">
                            <i class="fas fa-warehouse" aria-hidden="true"></i> {{ fornitore.DENOMINAZIONE_FORNITORE }}
                        </span>
                    </td>
                    <td style="width:20%">
                        <img :src="getImgPath(fornitore.URL)" alt="" class="img-responsive"
                            style="max-height:60px; ">
                    </td>
                    <td style="width:50%">
                        {{ fornitore.NOTE }}
                    </td>
                    <td style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica il fornitore"
                                class="btn btn-warning btn-sm float-right" v-on:click="modificaFornitore(fornitore)"><i
                                    class="fal fa-pencil"></i></button>
                            <!--                                 <button data-toggle="tooltip" data-placement="top" title="Elimina il fornitore" class="btn btn-danger btn-sm float-right" v-on:click="deleteFornitore(fornitore)"><i class="fal fa-trash-alt"></i></button>
 -->
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>

    <div class="modal fade" id="popUpFornitore" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" style="min-width:700px;">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background:#629991">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-building fa-fw"></i> Fornitore</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:390px">
                    <div class="row">
                        <div class="col-6">
                            <form>
                                <div class="form-group">
                                    <label>Denomiazione:</label>
                                    <input type="text" class="form-control form-control-sm"
                                        placeholder="Inserisci Denominazione..."
                                        v-model="fornitoreSelezionato.DENOMINAZIONE_FORNITORE">
                                </div>
                                <div class="form-group">
                                    <label>Note</label>
                                    <textarea class="form-control form-control-sm" rows="11"
                                        placeholder="Inserisci le tue note qui..."
                                        v-model="fornitoreSelezionato.NOTE"></textarea>
                                </div>
                            </form>
                        </div>
                        <div class="col-6">
                            <Upload @onsuccess="successCaricamento()" :w="90" :args="args"></Upload>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaFornitore()"><i
                            class="fa fa-check"></i> Salva</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Pagine from '@/components/utils/Pagine.vue'
import Upload from '@/components/utils/Upload.vue'


export default {
    name: "Fornitori",
    components: {
        Pagine,
        Upload
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                ID_FORNITORE: { TYPE: 'TEXT', VALUE: '' },
                DENOMINAZIONE_FORNITORE: { TYPE: 'TEXT', VALUE: '' }
            },
            arrayFornitori: new Array(),
            fornitoreSelezionato: {},
            args: { modalita: "ES_uploadImg" }
        }
    },
    methods: {
        successCaricamento: function () {

            utils.alert.success("Operazione correttamente eseguita");
            var modal = utils.closeModal('popUpFornitore');
            this.getFornitori();
        },
        getFornitori: function () {
            global.utils.get('/es/fornitori', {}, (response) => {
                this.arrayFornitori = response.data;
            });
        },
        creaFornitore: function () {
            this.fornitoreSelezionato = { ID_FORNITORE: 0 }
            var modal = utils.openModal('popUpFornitore');

        },
        modificaFornitore: function (fornitore) {
            //api fornitore
            this.fornitoreSelezionato = utils.clone(fornitore);
            this.args.ID_FORNITORE = this.fornitoreSelezionato.ID_FORNITORE;
            var modal = utils.openModal('popUpFornitore');
            /* global.utils.get('/es/fornitore',{ID_FORNITORE: fornitore.ID_FORNITORE},(response)=>{
                this.fornitoreSelezionato = utils.clone(response.data);

            }) */
        },
        deleteFornitore: function (fornitore) {
            utils.alert.confirm("Sei sicuro di voler eliminare il Fornitore selezionato?", () => {
                global.utils.delete('/es/fornitore', { ID_FORNITORE: fornitore.ID_FORNITORE }, (response) => {
                    /*  for (let i = 0; i < this.arrayFornitori.length; i++) {
                         if (this.arrayFornitori[i].ID_TEST == pagina.ID_TEST){
                             this.arrayFornitori.splice(i,1)
                         }
                     } */
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getFornitori();
                    }

                });
            }, this.$root);
        },
        salvaFornitore: function () {
            //update
            if (this.fornitoreSelezionato.ID_FORNITORE > 0) {
                global.utils.put('/es/fornitore', this.fornitoreSelezionato, (response) => {
                    if (response.esito == 0) {
                        this.getFornitori();
                        var modal = utils.closeModal('popUpFornitore')
                        utils.alert.success(response.messaggio);
                    }
                });
            } else {
                //insert
                global.utils.post('/es/fornitore', this.fornitoreSelezionato, (response) => {
                    if (response.esito == 0) {
                        this.getFornitori()
                        var modal = utils.closeModal('popUpFornitore')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        getImgPath: function (url) {
            return utils.BASE_API + "../../UPLOAD" + url;
        },
    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayFornitori, this.search);
            return arr;
        },
    },
    created: function () {
        this.getFornitori()
    },
}
</script>